import { useState } from "react";
import { useData } from "@/hooks/useData";
import { Residue } from "@/types/residue/residue.types";
import { useResidueFilters } from "./useResidueFilters";

export const useResidueTable = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [nameFilters, setNameFilters] = useState<string[]>([]);

    const {
        data: residues,
        loading,
        refetch,
    } = useData<Residue>({
        collectionName: "setup_residues",
    });

    const { filteredResidues, getUniqueOptions } = useResidueFilters({
        residues,
        searchTerm,
        nameFilters,
    });

    const clearFilters = () => {
        setSearchTerm("");
        setNameFilters([]);
    };

    const nameOptions = getUniqueOptions("name");

    return {
        residues,
        filteredResidues,
        loading,
        refetch,
        searchTerm,
        setSearchTerm,
        nameFilters,
        setNameFilters,
        clearFilters,
        nameOptions,
    };
}; 